"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSlideMixin = void 0;
var _styledComponents = require("styled-components");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var slideAlignCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('slideAlign', function (_ref) {
  var slideAlign = _ref.slideAlign;
  return (0, _styledComponents.css)(["scroll-snap-align:", ";"], slideAlign);
});
var slideWidthCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('slideWidth', function (_ref2) {
  var slideWidth = _ref2.slideWidth;
  return (0, _styledComponents.css)(["flex-basis:", ";"], slideWidth > 0 ? slideWidth + "px" : 'auto');
});

/** @class CarouselSlideMixin */
/** @method */
var CarouselSlideMixin = function CarouselSlideMixin(props) {
  return (0, _styledComponents.css)(["flex-grow:0;flex-shrink:0;", " ", ""], slideAlignCSS(props), slideWidthCSS(props));
};
exports.CarouselSlideMixin = CarouselSlideMixin;